// 設備詳細頁的分頁（SPEC DEV-05 / DEV-10「設備詳細頁分頁」；VMS UX 評審 2026-10-13 P1-6）：原本 12 個收成最多 7 個，網址 `?tab=`。
// 舊的 `?tab=` 值轉到新分頁與區塊（通知、書籤、舊連結照樣打得開）。純邏輯，畫面在 DeviceDetailPage。

export type DetailTab = 'overview' | 'live' | 'channels' | 'settings' | 'recording' | 'events' | 'health' | 'advanced';

/** 進階分頁的區（`?tab=advanced#manage` 這類錨點直接捲到那一區）；diag = Kinio Node 終端機（VMS UX 評審第三輪 R3-P0-4）。 */
export type AdvancedSection = 'technical' | 'location' | 'audit' | 'manage' | 'diag';
/** 設定分頁裡跟著設定表單的區（智慧分析、AI 指派、感測器關聯）。 */
export type SettingsSection = 'analytics' | 'ai' | 'links';

const LEGACY: Record<string, { tab: DetailTab; section?: string }> = {
  technical: { tab: 'advanced', section: 'technical' },
  location: { tab: 'advanced', section: 'location' },
  audit: { tab: 'advanced', section: 'audit' },
  manage: { tab: 'advanced', section: 'manage' },
  // 終端機不再是一級分頁（R3-P0-4）：舊 ?tab=console 帶到進階 › 診斷，不自動連線
  console: { tab: 'advanced', section: 'diag' },
  firmware: { tab: 'health', section: 'firmware' },
  ai: { tab: 'settings', section: 'ai' },
  analytics: { tab: 'settings', section: 'analytics' },
  links: { tab: 'settings', section: 'links' },
  subg: { tab: 'channels', section: 'subg' },
  site: { tab: 'channels', section: 'site' },
  nodes: { tab: 'channels', section: 'nodes' },
};

/** 網址的 tab 值 → 新分頁＋要捲到的區塊（舊值轉址）；不認得的回 null。 */
export function resolveTab(raw: string | null, hash = ''): { tab: DetailTab; section?: string } | null {
  if (!raw) return null;
  const legacy = LEGACY[raw];
  if (legacy) return legacy;
  const section = hash.replace(/^#/, '') || undefined;
  return { tab: raw as DetailTab, section };
}

/** 這台設備有哪些分頁（照出現條件；順序固定）。 */
export function detailTabs(c: {
  /** 有影像（攝影機、通道） */
  video: boolean;
  /** NVR / Kinio Station / 基地台本體：通道、子設備、現場設備、節點 */
  host: boolean;
  /** 有錄影能力（攝影機、通道）或有儲存（NVR / Station 的碟） */
  recording: boolean;
}): DetailTab[] {
  return [
    'overview',
    ...(c.host ? (['channels'] as DetailTab[]) : c.video ? (['live'] as DetailTab[]) : []),
    'settings',
    ...(c.recording ? (['recording'] as DetailTab[]) : []),
    'events',
    'health',
    'advanced',
  ];
}
